module.exports = __webpack_public_path__ + "static/img/sspg_03.de96d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_03.jpg
// module id = T100
// module chunks = 1